import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import { t } from 'i18next';

import { Typography } from '@mui/material';

import { useAbilityContext } from '@/contexts/ability';
import { getTodayDate } from '../../../utils/date';
import { convertCurrency, convertAmount } from '../../../utils/amount';

import { useCreateUrl } from '../../../hooks/useNavigate';

export const CommittedApplications = ({ currency, amount }) => {
  const createUrl = useCreateUrl();
  const ability = useAbilityContext();

  const baseUrl = ability.can('enabled', 'investments-v2')
    ? '/v2/investments/portfolio/committed' : '/investments/applications/committed';

  return (
    <Typography>
      {t('You have a total of {{currency}} {{amount}} in Committed investments that expire today.', {
        currency: convertCurrency(currency),
        amount: convertAmount(currency, amount),
      })}
      <Link to={createUrl(baseUrl, { dueDate: getTodayDate() })}>
        {t('See here')}
        .
      </Link>
    </Typography>
  );
};

CommittedApplications.propTypes = {
  currency: PropTypes.string,
  amount: PropTypes.number,
};
